import React from "react";
import { Row, Col } from "reactstrap";
import PropTypes from "prop-types";

import { env } from "@bkry/bowline-utils";
import ArtistModal from "../ArtistModal";
const { REACT_APP_CDN_PATH } = env;

const SectionWithModal = (props) => {
  const { section } = props;
  return (
    <Row className="bigger-margin-bottom">
      <Col
        xs={{ size: 12, order: 2 }}
        lg={{ size: 5, order: 1 }}
        className="d-flex flex-column justify-content-between"
      >
        <div>
          {section.subtitle && (
            <p className="text-uppercase">{section.subtitle}</p>
          )}
          {section.title && (
            <h1 className="mb-5 display-4" style={{ whiteSpace: "pre-wrap" }}>
              {section.title}
            </h1>
          )}
        </div>
        <div className="mb-5">
          {section.text && (
            <p style={{ whiteSpace: "pre-wrap" }}>{section.text}</p>
          )}
          {section.modal && (
            <ArtistModal
              subHeader={section.modal.subHeader}
              headline={section.modal.headline}
              text={section.modal.text}
              items={section.modal.items}
              twitter={section.modal.twitter}
              insta={section.modal.insta}
              youtube={section.modal.youtube}
              discord={section.modal.discord}
              linkedin={section.modal.linkedin}
              tiktok={section.modal.tiktok}
              twitch={section.modal.twitch}
              telegram={section.modal.telegram}
              medium={section.modal.medium}
              opensea={section.modal.opensea}
              link={section.modal.link}
            />
          )}
        </div>
      </Col>
      <Col
        xs={{ size: 12, order: 1 }}
        lg={{ size: 7, order: 2 }}
        className="mb-4 mb-lg-0"
      >
        {section.image && (
          <img
            src={(REACT_APP_CDN_PATH || "") + section.image}
            alt="artist"
            height="auto"
            width="100%"
          />
        )}
      </Col>
    </Row>
  );
};

/**  define proptype for the 'translation' function  */
SectionWithModal.contextTypes = {
  t: PropTypes.func,
};

SectionWithModal.propTypes = {
  section: PropTypes.object.isRequired,
};

SectionWithModal.defaultProps = {};

export default SectionWithModal;
